<div *transloco="let transloco" [attr.inert]="this.props.readonly ? '' : null" class="flex">
  <p-selectButton
    (onChange)="this.props.change && this.props.change(this.field, $event)"
    [allowEmpty]="false"
    [formControl]="this.formControl"
    [formlyAttributes]="this.field"
    [ngClass]="{
      'ng-dirty ng-invalid p-invalid': this.showError
    }"
    [optionLabel]="this.props.optionLabel || 'label'"
    [optionValue]="this.props.optionValue || 'value'"
    [options]="(this.props.options | formlySelectOptions: this.field | async)!">
    <ng-template #item let-item>
      {{ transloco(item['label']) }}
    </ng-template>
  </p-selectButton>
</div>
